import React, { useState, useEffect } from "react";
import styles from "./ProfileImage.module.css";
import { StoreService } from "../../services/store-service";

const processImage = (profileData: string | undefined): string => {
  return profileData || "/assets/images/freeface.jpg"; 
};

interface ProfileImageProps {
  image?: string;
  altText?: string;
  size?: number;
  partnerId?: number;
}

const ProfileImage: React.FC<ProfileImageProps> = ({
  image,
  altText = "Profile Image",
  size = 120,
  partnerId,
}) => {
  const [profileImage, setProfileImage] = useState<string>(processImage(image));

  useEffect(() => {
    if (!image && partnerId !== undefined) {
      const storedPartners = StoreService.GetData("partners") || [];
      const foundPartner = storedPartners.find((partner: any) => partner.id === partnerId);

      if (foundPartner?.profile) {
        setProfileImage(processImage(foundPartner.profile));
      } else {
        setProfileImage("/assets/images/freeface.jpg"); 
      }
    }
  }, [image, partnerId]);

  const handleImageError = () => {
    setProfileImage("/assets/images/freeface.jpg");  
  };

  return (
    <div
      className={styles.container}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <img
        src={profileImage}
        alt={altText}
        className={styles.image}
        style={{
          width: `${size - 10}px`,
          height: `${size - 10}px`,
        }}
        onError={handleImageError} 
      />
    </div>
  );
};

export default ProfileImage;
